import React, { useMemo } from 'react';
import { TitleTextAreaField } from '@warehouse/title/ui';
import { titlePaths } from '@warehouse/title/core';

export function Summary4000Field({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.summary4000(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextAreaField label="Summary 4000" path={path} />;
}
